import { useSelector } from 'react-redux';
// eslint-disable-next-line import/no-unresolved
import { Content } from '@plone/types';
import View from './View';

const Edit = ({ content }: { content: Content }) => {
  const formData = useSelector(
    (state: { form: { global: Content } }) => state.form.global,
  );
  return <View isEdit isViewOrEdit content={formData || content} />;
};

export default Edit;
